<template>
  <TModal
    v-if="generalStore.developerModalOpened"
    xs
    @close="generalStore.developerModalOpened = false"
  >
    <template #dialog-body>
      <div class="w-[300px] px-10">
        <!-- <div
          class="border-2 text-gray-200 flex justify-center border-dotted items-center border-gray-400 rounded-md bg-gray-700 h-20 w-full"
        >
          Drop template here
        </div> -->

        <div class="hidden">
          <label for="json-template-upload"></label>
          <input
            id="json-template-upload"
            ref="jsonTemplateUpload"
            type="file"
            accept=".json"
            @change="onFileChanged($event)"
          />
        </div>

        <div class="mt-10 space-y-4">
          <TButton class="w-full" @click="selectFile">
            Select file from computer</TButton
          >

          <TButton
            v-if="isSupported"
            class="w-full"
            @click="copyTemplateToClipboard"
          >
            Copy Template to clipboard</TButton
          >
          <TButton class="w-full" @click="downloadTemplateAsJson">
            Download Template in JSON</TButton
          >
        </div>

        <div class="border-gray-150 mt-4">
          <p class="mb-2 text-gray-100">Settings</p>
          <TCheckBox
            v-model="sectionVariantsStore.enableSectionVariants"
            label="Enable section variants"
          ></TCheckBox>
          <TCheckBox
            v-model="mergeTagsStore.enableMergeTagPreview"
            label="Enable merge tag preview"
          ></TCheckBox>
          <TCheckBox
            v-model="testingEmails"
            label="Enable more than one testing email"
          ></TCheckBox>
        </div>
      </div>
    </template>
  </TModal>
</template>

<script setup lang="ts">
  import { useGeneralStore } from "@/stores/generalStore";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useSavedBlocksStore } from "@/stores/savedBlocksStore";
  import { useSectionVariantsStore } from "@/stores/sectionVariantsStore";
  import { useMergeTagsStore } from "@/stores/mergeTags";
  import { usePreviewStore } from "@/stores/preview";

  import { TModal, TButton, TCheckBox } from "@topol/twig-ui";

  import { useClipboard } from "@vueuse/core";
  import { computed } from "vue";

  const savedBlocksStore = useSavedBlocksStore();
  const sectionVariantsStore = useSectionVariantsStore();
  const mergeTagsStore = useMergeTagsStore();
  const previewStore = usePreviewStore();

  const { copy, isSupported } = useClipboard();
  const generalStore = useGeneralStore();
  const mjmlStore = useMjmlStore();

  const testingEmails = computed({
    get() {
      return previewStore.testingEmailAddresses !== undefined;
    },
    set(value: boolean) {
      if (value) {
        if (localStorage.getItem("testingEmailAddresses")) {
          previewStore.testingEmailAddresses = JSON.parse(
            localStorage.getItem("testingEmailAddresses") as string
          );
        } else {
          previewStore.testingEmailAddresses = [];
          localStorage.setItem("testingEmailAddresses", "[]");
        }
      } else {
        previewStore.testingEmailAddresses = undefined;
      }
    },
  });

  function copyTemplateToClipboard() {
    try {
      copy(JSON.stringify(mjmlStore.getMjml()));
    } catch (error) {
      return;
    }
  }

  function downloadTemplateAsJson() {
    const element = document.createElement("a");
    const file = new Blob([JSON.stringify(mjmlStore.getMjml())], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download = `template-${new Date().toISOString()}.json`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  function selectFile() {
    const input = document.getElementById("json-template-upload");
    if (input) {
      input.click();
    }
  }

  function closeModal() {
    generalStore.developerModalOpened = false;
  }

  function onFileChanged(event: any) {
    const file = event.target.files[0];

    const reader = new FileReader();

    reader.readAsText(file, "utf-8");

    reader.onload = () => {
      const jsonContent = reader.result as string;
      const template = JSON.parse(jsonContent);

      mjmlStore.setMjml(template);

      if (savedBlocksStore.syncedSectionsEnabled) {
        window.$event.emit("refreshSyncedSections");
      }

      closeModal();
    };
  }
</script>
